<div class="modal-header">
    <h4 class="modal-title">{{my_modal_title}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
  <div class="container">
  <p>Proporcina quien sera notificado</p>
  
    <div class="form-horizontal">
      <div class="form-group">
        <div class="col-sm-2">
          <label for="signant_name" class="control-label">Nombre</label>
        </div>
        <div class="col-sm-10">
          <input class="form-control" type="text" name="signant_name" id="signant_name" [(ngModel)]="reviewers.name" placeholder="Humberto Martinez">
        </div>
      </div>
      <div class="form-group">
        <div class="col-sm-2">
          <label for="signant_name" class="control-label">Email</label>
        </div>
        <div class="col-sm-10">
          <input type="email" 
          name="email_person" 
          id="signant_email" 
          class="form-control"
          [(ngModel)]="reviewers.email_person" required email #emailInput="ngModel" placeholder="signer1@email.com">
          <div *ngIf="!reviewers.email_person && (emailInput.dirty || emailInput.touched)">
            <div *ngIf="!reviewers.email_person">Email is required.</div>
            <div *ngIf="emailInput.errors?.email">Invalid email format.</div>
          </div>
        </div>
      </div>
    </div>    
  </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="closeModalWithoutResult()">Cerrar</button>
    <div *ngIf="reviewers.email_person">
      <button type="button" class="btn btn-success btn-outline-dark" (click)="closeModalWithResult()">Agregar</button>
    </div>
    <!-- <button type="button" class="btn btn-success btn-outline-dark" (click)="closeModalWithResult()">Agregar</button> -->
  </div>
  